export default __webpack_public_path__ + "static/media/daihao.0d60477e.png";